import { render, staticRenderFns } from "./dialogTable.vue?vue&type=template&id=146f5108&scoped=true&"
import script from "./dialogTable.vue?vue&type=script&lang=js&"
export * from "./dialogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146f5108",
  null
  
)

export default component.exports